// extracted by mini-css-extract-plugin
export default {"div":"time_div__Ig27T","input":"time_input__mOG8B","err":"time_err__fJQ2U","label":"time_label__Yl2Sb","msg":"time_msg__XSgYe","highlight":"time_highlight__gA8Ix"};